var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var SET_FIELD = 'SET_FIELD';
export var RESET_STATE = 'RESET_STATE';
export var CHANGE_FOCUS = 'CHANGE_FOCUS';
export var UPDATE_BUTTON_FOCUS = 'UPDATE_BUTTON_FOCUS';
export var setField_AC = function (key, value) {
    return {
        type: SET_FIELD,
        payload: {
            key: key,
            value: value,
        },
    };
};
export var resetField_Ac = function (payload) {
    return {
        type: RESET_STATE,
        payload: __assign({}, payload),
    };
};
export var changeFocus_Ac = function (windowId, widgetId) {
    return {
        type: CHANGE_FOCUS,
        payload: {
            windowId: windowId,
            widgetId: widgetId,
        },
    };
};
export var updateButtonFocus_Ac = function (buttonId) {
    return {
        type: UPDATE_BUTTON_FOCUS,
        payload: {
            buttonId: buttonId,
        },
    };
};
//# sourceMappingURL=actions.js.map